import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Trigger = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Trigger' {...props}>
    <polygon fill='none' stroke='#000' strokeWidth='2' points='4 14 10 14 7 23 9 23 20 9 14 9 18 1 7 1' />
  </StyledIcon>
);
